import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import preview from './strategyParametersPreview.png';

export const strategyParametersDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The Instinet Algo Parameters table lists the full set of
                parameters as well as any revisions of your Instinet algo, SOR
                and DMA orders.
            </div>
        </>
    ),
    previews: [{ src: preview, altText: 'strategy-params-preview' }],
};
